export type CardFee = {
  deviceId?: string;
  cardProviderName?: string;
  percentage?: string;
  terminalType?: TerminalType;
};

export enum TerminalType {
  CARD_NOT_PRESENT,
  CARD_PRESENT,
}

export type CardFeesData = {
  card_type: 'Credit Card' | 'Debit Card' | '';
  demographic: 'Domestic' | 'International';
  fee_category: 'Card Not Present' | 'Card Present';
  max_turnover: string;
  min_turnover: string;
  percentage: string;
  pricing_tier: 'Fixed' | 'Variable';
  pricing_tier_name: string;
  product_name: 'VISA' | 'Amex' | 'Diners' | 'Mastercard' | 'International';
};
